export default "__VITE_ASSET__D5EZz7Gf__"